import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useModal } from "../../context/ModalContext";
import { useNotifications } from "../../context/NotificationContext";
import searchService from "../../services/search";
import avatar from "../../assets/images/user-avatar.png"

const IconSearch = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="7" />
    <line x1="16.5" y1="16.5" x2="21" y2="21" />
  </svg>
);

const IconBell = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const IconChevronDown = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const IconUser = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const IconSettings = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3.6 15a1.65 1.65 0 0 0-1.51-1H2a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 3.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 8 4.6 1.65 1.65 0 0 0 9 3.09V3a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 16 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 20.4 9c.36.53.56 1.16.6 1.8V11a1.65 1.65 0 0 0-1 1.51z" />
  </svg>
);

const IconLogout = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const IconTask = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

const IconBranch = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconLoader = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="search-spinner"
  >
    <line x1="12" y1="2" x2="12" y2="6" />
    <line x1="12" y1="18" x2="12" y2="22" />
    <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" />
    <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" />
    <line x1="2" y1="12" x2="6" y2="12" />
    <line x1="18" y1="12" x2="22" y2="12" />
    <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" />
    <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" />
  </svg>
);

const IconMenu = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

// Debounce hook
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export default function Topbar({ onMenuClick }) {
  const { user, logout } = useAuth();
  const { openTaskModal, openBranchModal } = useModal();
  const { notifications, unreadCount, markAsRead, markAllAsRead, refresh: refreshNotifications } = useNotifications();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef(null);
  const notifRef = useRef(null);

  // Search state
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState({ tasks: [], branches: [] });
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const searchRef = useRef(null);
  const searchInputRef = useRef(null);

  // Debounce search query
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  // Perform search when debounced query changes
  useEffect(() => {
    const performSearch = async () => {
      if (debouncedSearchQuery.trim().length < 2) {
        setSearchResults({ tasks: [], branches: [] });
        setShowSearchDropdown(false);
        return;
      }

      setIsSearching(true);
      try {
        const results = await searchService.globalSearch(debouncedSearchQuery);
        setSearchResults(results);
        setShowSearchDropdown(true);
      } catch (error) {
        console.error('Search error:', error);
        setSearchResults({ tasks: [], branches: [] });
      } finally {
        setIsSearching(false);
      }
    };

    performSearch();
  }, [debouncedSearchQuery]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value.trim().length >= 2) {
      setShowSearchDropdown(true);
    }
  };

  // Handle search result click - open modal instead of navigating
  const handleResultClick = (type, item) => {
    setShowSearchDropdown(false);
    setSearchQuery('');

    if (type === 'task') {
      openTaskModal(item._id);
    } else if (type === 'branch') {
      openBranchModal(item._id);
    }
  };

  // Handle keyboard navigation
  const handleSearchKeyDown = (e) => {
    if (e.key === 'Escape') {
      setShowSearchDropdown(false);
      searchInputRef.current?.blur();
    }
  };

  // Get status color for tasks
  const getStatusColor = (status) => {
    const colors = {
      pending: '#f59e0b',
      assigned: '#3b82f6',
      'in-transit': '#8b5cf6',
      delivered: '#10b981',
      cancelled: '#ef4444',
    };
    return colors[status] || '#6b7280';
  };

  // Check if there are any results
  const hasResults = searchResults.tasks.length > 0 || searchResults.branches.length > 0;

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const getUserDisplayName = () => {
    if (!user) return 'User';
    return `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || 'User';
  };

  const getCompanyName = () => {
    if (!user?.company?.name) return 'My Company';
    return user.company.name;
  };

  const formatTimeAgo = (dateStr) => {
    const now = new Date();
    const date = new Date(dateStr);
    const diff = Math.floor((now - date) / 1000);
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return date.toLocaleDateString();
  };

  const getNotifIcon = (type) => {
    const icons = {
      job_created: '📦',
      job_assigned: '🚚',
      job_status_changed: '🔄',
      job_completed: '✅',
      job_exception: '⚠️',
      driver_online: '🟢',
      driver_offline: '🔴',
      driver_status_changed: '👤',
      new_review: '⭐',
      system: '🔔',
    };
    return icons[type] || '🔔';
  };

  return (
    <header className="mq-topbar">
      {/* Mobile menu button */}
      <button className="mq-menu-button" onClick={onMenuClick} type="button" aria-label="Open menu">
        <IconMenu />
      </button>

      {/* Left: Search bar */}
      <div className="mq-search-box" ref={searchRef}>
        <span className="mq-search-icon">
          {isSearching ? <IconLoader /> : <IconSearch />}
        </span>
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Search jobs, branches..."
          className="mq-search-input"
          value={searchQuery}
          onChange={handleSearchChange}
          onKeyDown={handleSearchKeyDown}
          onFocus={() => {
            if (searchQuery.trim().length >= 2 && hasResults) {
              setShowSearchDropdown(true);
            }
          }}
        />

        {/* Search Results Dropdown */}
        {showSearchDropdown && (
          <div className="mq-search-dropdown">
            {isSearching ? (
              <div className="mq-search-loading">
                <IconLoader />
                <span>Searching...</span>
              </div>
            ) : !hasResults ? (
              <div className="mq-search-empty">
                <span>No results found for "{searchQuery}"</span>
              </div>
            ) : (
              <>
                {/* Tasks Section */}
                {searchResults.tasks.length > 0 && (
                  <div className="mq-search-section">
                    <div className="mq-search-section-header">
                      <IconTask />
                      <span>Jobs / Tasks</span>
                    </div>
                    {searchResults.tasks.map((task) => (
                      <div
                        key={task._id}
                        className="mq-search-result-item"
                        onClick={() => handleResultClick('task', task)}
                      >
                        <div className="mq-search-result-content">
                          <div className="mq-search-result-title">
                            {task.jobId || task._id?.slice(-8)}
                          </div>
                          <div className="mq-search-result-subtitle">
                            {task.from?.name || task.from?.address || 'Unknown'} → {task.to?.name || task.to?.address || 'Unknown'}
                          </div>
                        </div>
                        <span
                          className="mq-search-result-badge"
                          style={{ backgroundColor: getStatusColor(task.status) }}
                        >
                          {task.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Branches Section */}
                {searchResults.branches.length > 0 && (
                  <div className="mq-search-section">
                    <div className="mq-search-section-header">
                      <IconBranch />
                      <span>Branches</span>
                    </div>
                    {searchResults.branches.map((branch) => (
                      <div
                        key={branch._id}
                        className="mq-search-result-item"
                        onClick={() => handleResultClick('branch', branch)}
                      >
                        <div className="mq-search-result-content">
                          <div className="mq-search-result-title">
                            {branch.name}
                          </div>
                          <div className="mq-search-result-subtitle">
                            {branch.code} • {branch.address?.city || branch.fullAddress || 'Unknown location'}
                          </div>
                        </div>
                        <span
                          className="mq-search-result-badge"
                          style={{ backgroundColor: branch.isActive ? '#10b981' : '#6b7280' }}
                        >
                          {branch.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>

      {/* Right: User pill and bell */}
      <div className="mq-topbar-right">
        <div className="mq-user-pill-container" ref={dropdownRef}>
          <button
            className="mq-user-pill"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            type="button"
          >
            <img
              src={user?.avatar || avatar}
              alt={getUserDisplayName()}
              className="mq-user-avatar"
            />
            <div className="mq-user-info">
              <span className="mq-user-name">{getUserDisplayName()}</span>
              <span className="mq-company-name">{getCompanyName()}</span>
            </div>
            <IconChevronDown />
          </button>

          {dropdownOpen && (
            <div className="mq-user-dropdown">
              <div className="mq-dropdown-item" onClick={() => { navigate('/settings'); setDropdownOpen(false); }}>
                <IconUser />
                <span>Profile</span>
              </div>
              <div className="mq-dropdown-item" onClick={() => { navigate('/settings'); setDropdownOpen(false); }}>
                <IconSettings />
                <span>Settings</span>
              </div>
              <div className="mq-dropdown-divider"></div>
              <div className="mq-dropdown-item mq-dropdown-item-danger" onClick={handleLogout}>
                <IconLogout />
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>

        <div className="mq-notif-section" ref={notifRef}>
          <button
            className="mq-bell-button"
            type="button"
            onClick={() => {
              setShowNotifications(!showNotifications);
              if (!showNotifications) refreshNotifications();
            }}
          >
            <IconBell />
            {unreadCount > 0 && <span className="mq-bell-dot" />}
          </button>

          {showNotifications && (
            <div className="mq-notif-dropdown">
              <div className="mq-notif-dropdown-header">
                <span className="mq-notif-title">Notifications</span>
                {unreadCount > 0 && (
                  <button
                    className="mq-notif-mark-all"
                    onClick={markAllAsRead}
                    type="button"
                  >
                    Mark all read
                  </button>
                )}
              </div>
              {notifications.length === 0 ? (
                <div className="mq-notif-empty">
                  <IconBell />
                  <span>No notifications yet</span>
                </div>
              ) : (
                <div className="mq-notif-list">
                  {notifications.map((notif) => (
                    <div
                      key={notif._id}
                      className={`mq-notif-item ${!notif.isRead ? 'mq-notif-unread' : ''}`}
                      onClick={() => {
                        if (!notif.isRead) markAsRead(notif._id);
                        if (notif.refModel === 'Job' && notif.refId) {
                          openTaskModal(notif.refId);
                          setShowNotifications(false);
                        }
                      }}
                    >
                      <div className="mq-notif-icon">
                        {getNotifIcon(notif.type)}
                      </div>
                      <div className="mq-notif-content">
                        <div className="mq-notif-item-title">{notif.title}</div>
                        <div className="mq-notif-item-message">{notif.message}</div>
                        <div className="mq-notif-item-time">{formatTimeAgo(notif.createdAt)}</div>
                      </div>
                      {!notif.isRead && <span className="mq-notif-unread-dot" />}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
